import { gql } from 'apollo-angular';

// Query to get the external share link URLs for an equipment counting journal.
// The API signs fresh 14-day tokens on every read. batchShareLinkURL is only
// returned when the journal was batch-created alongside other journals; it
// opens a combined read-only view of every journal in the batch.
export const QUERY_GetEquipmentCountingJournalShareLink = gql`
  query ($id: String!) {
    getEquipmentCountingJournal(id: $id) {
      id
      shareLinkURL
      batchShareLinkURL
    }
  }
`;
